<mat-card class="__card  z-manual-elevation  c-soft-elevation">

  <h4 class="__title">
    Oof, something went wrong …
  </h4>

  <div class="__content">
    @for (item of data; let index = $index; track index) {
      <div>
        {{ item.message }}
      </div>
      @if (item.originalError?.error?.error?.meta?.length) {
        @for (meta of item.originalError?.error?.error?.meta; let index = $index; track index) {
          <div
            class="__meta">
            @if (meta.parameter) {
              <span>{{ meta.parameter }}</span>
            }
            @if (meta.parameter) {
              -
            }
            @if (meta.message) {
              <span>{{ meta.message }}</span>
            }
          </div>
        }
      }
    }
  </div>

  <button
    mat-button
    class="__button  c-button--full"
    (click)="instance.close()">
    <mat-icon class="__button_icon">report</mat-icon> Okay, close.
  </button>

</mat-card>